const DEFAULT_YAW_THRESHOLD = 50;
const DEFAULT_PITCH_DOWN_THRESHOLD = 0.42;
const DEFAULT_PITCH_UP_THRESHOLD = 0.02;
const DEFAULT_DURATION_MS = 15000;

export const lookingAwayState = {
  lookingAwayStart: null,
  lookingAwayYawThreshold: DEFAULT_YAW_THRESHOLD,
  lookingAwayPitchDownThreshold: DEFAULT_PITCH_DOWN_THRESHOLD,
  lookingAwayPitchUpThreshold: DEFAULT_PITCH_UP_THRESHOLD,
  lookingAwayDurationMs: DEFAULT_DURATION_MS,
};

export const lookingAwayGetters = {};

export const lookingAwayMutations = {
  SET_LOOKING_AWAY_START(state, val) {
    state.lookingAwayStart = val;
  },
  SET_LOOKING_AWAY_CONFIG(state, config) {
    if (config.yawThreshold !== undefined)
      state.lookingAwayYawThreshold = config.yawThreshold;
    if (config.pitchDownThreshold !== undefined)
      state.lookingAwayPitchDownThreshold = config.pitchDownThreshold;
    if (config.pitchUpThreshold !== undefined)
      state.lookingAwayPitchUpThreshold = config.pitchUpThreshold;
    if (config.durationMs !== undefined)
      state.lookingAwayDurationMs = config.durationMs;
  },
};

export const lookingAwayActions = {
  checkLookingAway({ state, commit, dispatch }, { landmarks }) {
    const nose = landmarks[1];
    const leftEye = landmarks[33];
    const rightEye = landmarks[263];
    const forehead = landmarks[10];
    const chin = landmarks[152];

    const eyeCenterX = (leftEye.x + rightEye.x) / 2;
    const yawDeviation = Math.abs(nose.x - eyeCenterX);
    const eyeCenterY = (leftEye.y + rightEye.y) / 2;
    const faceHeight = Math.abs(chin.y - forehead.y) || 1;
    const pitchRatio = (nose.y - eyeCenterY) / faceHeight;

    const isLookingAway =
      yawDeviation > state.lookingAwayYawThreshold ||
      pitchRatio > state.lookingAwayPitchDownThreshold ||
      pitchRatio < state.lookingAwayPitchUpThreshold;

    if (isLookingAway) {
      const now = Date.now();

      if (!state.lookingAwayStart) {
        commit("SET_LOOKING_AWAY_START", now);
      } else if (now - state.lookingAwayStart >= state.lookingAwayDurationMs) {
        dispatch("triggerViolation", {
          type: "LOOKING_AWAY",
          reason: "Looking away",
        });
        commit("SET_LOOKING_AWAY_START", now);
      }
    } else {
      commit("SET_LOOKING_AWAY_START", null);
    }
  },

  cleanupLookingAway({ commit }) {
    commit("SET_LOOKING_AWAY_START", null);
  },
};
